import React, { useEffect, useState } from "react";
import { useGetSolutionsByTagQuery } from "../store/slices/settingsSlice";
import SolutionsFilter from "./SolutionsFilter";
import SolutionsCardList from "./SolutionsCardList";
import MyCollapse from "../Common/MyCollapse";

export default function SolutionsStore() {
  const [filters, setFilters] = useState(
    localStorage.getItem("solutionsLibraryFilters")
      ? JSON.parse(localStorage.getItem("solutionsLibraryFilters"))
      : {
          status: [],
          kind: [],
          search: "",
          purchased: "yes",
          deployed: "",
          industry: [],
        }
  );

  useEffect(() => {
    localStorage.setItem("solutionsLibraryFilters", JSON.stringify(filters));
  }, [filters]);

  const solutionsTagsSummary = useGetSolutionsByTagQuery({
    limit: 1000,
    ...filters,
  });

  return (
    <div>
      <SolutionsFilter filters={filters} setFilters={setFilters} />

      {solutionsTagsSummary.data?.tags
        ?.slice()
        ?.sort((a, b) => (a.Tag > b.Tag ? 1 : -1))
        ?.map((category) => (
          <div key={category.Tag} className="mb-4">
            <span className="mb-3 fw-bold fs-2">{category.Tag}</span>
            <span className="ms-2 text-navy">
              <span className="fw-bold"> ({category.Mine}</span> purchased from
              total of <span className="fw-bold">{category.Total}</span>)
            </span>
            <div
              className="d-flex gap-3 overflow-x-auto fluid"
              style={{ height: "fit-content" }}
            >
              <SolutionsCardList
                filters={{ ...filters, category: category.Tag }}
              />
            </div>
          </div>
        ))}
      <MyCollapse heading="All solutions">
        <div
          className="d-flex gap-3 overflow-x-auto fluid"
          style={{ height: "fit-content" }}
        >
          <SolutionsCardList filters={{ ...filters, category: "" }} />
        </div>
      </MyCollapse>
    </div>
  );
}
